import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import 'react-base-table/styles.css'

import parse from 'html-react-parser';

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqPOST, reqPUT, reqDELETE, translate } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    
    const entities_list = useRef(null);

    const suppliers_list = useRef(null);
    const suppliers_list_active = useRef(null);
    const suppliers_list_by_name_active = useRef(null);
    const suppliers_list_by_tipo_active = useRef(null);
    const suppliers_list_by_tipo_classificacao_active = useRef(null);
    const suppliers_list_by_month_active = useRef(null);
    const supplier_active = useRef(null);
    const new_year = useRef(null);
    const year_active = useRef(null);
    const years_actives = useRef(null);

    const evaluating_criteria_types = useRef(null);
    const evaluating_supply_quality_types = useRef(null);
    const evaluating_supply_types = useRef(null);
    const evaluating_supplier_types = useRef(null);
    
    const suppliers_list_by_classificacao_active = useRef(null);
    const suppliers_list_by_classificacao_tipo_prod_active = useRef(null);
    const suppliers_list_by_classificacao_tipo_prod_2_active = useRef(null);

    const total_fonecimentos = useRef(null);
    const total_fonecimentos_avaliados = useRef(null);
    const total_tx_avaliados = useRef(null);

    const total_ocorrencias_list = useRef(null);

    const [show_table, set_show_table] = useState(0);

    const new_row = useRef(null);
    const active_row = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [_loading_, set_loading_] = useState(false);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const [refresh, setRefresh] = useState(0);

    const [months_list, ] = useState([
        {
            id: '01',
            name: 'Janeiro'
        },
        {
            id: '02',
            name: 'Fevereiro'
        },
        {
            id: '03',
            name: 'Março'
        },
        {
            id: '04',
            name: 'Abril'
        },
        {
            id: '05',
            name: 'Maio'
        },
        {
            id: '06',
            name: 'Junho'
        },
        {
            id: '07',
            name: 'Julho'
        },
        {
            id: '08',
            name: 'Agosto'
        },
        {
            id: '09',
            name: 'Setembro'
        },
        {
            id: '10',
            name: 'Outubro'
        },
        {
            id: '11',
            name: 'Novembro'
        },
        {
            id: '12',
            name: 'Dezembro'
        }
    ])

	const order_array_numero = (array) => {

		return array.sort((a, b) => {
			// const nameA = parseInt(a.info.settings.numero.split('/')[0]); // ignore upper and lowercase
			// const nameB = parseInt(b.info.settings.numero.split('/')[0]); // ignore upper and lowercase
            const nameA = parseInt(a.id); // ignore upper and lowercase
			const nameB = parseInt(b.id); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

    const fetch_entities_list = async () => {

        let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
        let result = []
        if (res.data !== undefined) {
            result = res.data.filter(el => parseInt(el.entity_type) === parseInt('2'))
        }

        return result

    }
    
    const fetch_quality_attributes = async (type) => {

        let res = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/${type}/active`)
        let result = []
        if (res.data !== undefined) {
            for await (let el of res.data) {

                let aux = {
                    id: el.id,
                    name: translate(el.info.title, 'pt'),
                    obs: translate(el.info.description, 'pt'),
                    warning: translate(el.info.warning, 'pt'),
                    value: el.info.weighting,
                    more: el.info.more,
                    less: el.info.less
                }

                result.push(aux)
            }
        }

        return result

    }

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

    const get_attr = async () => {

        let res_1 = await fetch_quality_attributes('supplier_evaluation_type')
        if (res_1.length > 0) {
            // res_1 = order_array(res_1)

            let res_aux_1 = []
            for await (let el of res_1) {
                res_aux_1.push({
                    id: el.id,
                    label: el.name,
                    value: el.value
                })
            }
            set_dados(evaluating_criteria_types.current = res_aux_1)
        }
        let res_2 = await fetch_quality_attributes('supply_quality_type')
        if (res_2.length > 0) {
            // res_2 = order_array(res_2)

            let res_aux_2 = []
            for await (let el of res_2) {
                res_aux_2.push({
                    id: el.id,
                    label: el.name,
                    more: el.more,
                    less: el.less
                })
            }
            set_dados(evaluating_supply_quality_types.current = res_aux_2)
        }
        let res_3 = await fetch_quality_attributes('supplier_quality_type')
        if (res_3.length > 0) {
            // res_3 = order_array(res_3)

            let res_aux_3 = []
            for await (let el of res_3) {
                res_aux_3.push({
                    id: el.id,
                    label: el.name,
                    obs: el.obs,
                    warning: el.warning,
                    more: el.more,
                    less: el.less
                })
            }
            set_dados(evaluating_supplier_types.current = res_aux_3)
        }
        let res_4 = await fetch_quality_attributes('supply_type')
        if (res_4.length > 0) {
            res_4 = order_array(res_4)

            let res_aux_4 = []
            for await (let el of res_4) {
                res_aux_4.push({
                    id: el.id,
                    label: el.name
                })
            }
            set_dados(evaluating_supply_types.current = res_aux_4)
        }
        let res_5 = await fetch_entities_list()
        if (res_5.length > 0) {
            res_5 = order_array(res_5)

            let res_aux_5 = []
            for await (let el of res_5) {
                res_aux_5.push({
                    id: el.id,
                    label: el.name,
                    email: el.email
                })
            }
            set_dados(entities_list.current = res_aux_5)
        }

        return true

    }
    
    const get_info = async () => {

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(async res => {
                if (res.data[0] !== undefined) {

                    // for await (let el of res.data) {

                    //     let el_aux = JSON.parse(JSON.stringify(el))
                    //     if(el_aux.info.settings['avaliado'] !== undefined && el_aux.info.settings['avaliado'] !== null && el_aux.info.settings['avaliado'] === true) {
                            // if(el_aux.info.settings.conformidade !== undefined && el_aux.info.settings.conformidade !== null) {
                            //     el_aux.info.settings['evaluation_type_id_42'] = el_aux.info.settings.conformidade
                            // }
                            // if(el_aux.info.settings.prazo !== undefined && el_aux.info.settings.prazo !== null) {
                            //     el_aux.info.settings['evaluation_type_id_43'] = el_aux.info.settings.prazo
                            // }
                            // if(el_aux.info.settings.faturacao !== undefined && el_aux.info.settings.faturacao !== null) {
                            //     el_aux.info.settings['evaluation_type_id_44'] = el_aux.info.settings.faturacao
                            // }
                            // if(el_aux.info.settings.resposta !== undefined && el_aux.info.settings.resposta !== null) {
                            //     el_aux.info.settings['evaluation_type_id_45'] = el_aux.info.settings.resposta
                            // }
                            // if(el_aux.info.settings.reclamacao !== undefined && el_aux.info.settings.reclamacao !== null) {
                            //     el_aux.info.settings['evaluation_type_id_46'] = el_aux.info.settings.reclamacao
                            // }
                            // if(el_aux.info.settings.atendimento !== undefined && el_aux.info.settings.atendimento !== null) {
                            //     el_aux.info.settings['evaluation_type_id_47'] = el_aux.info.settings.atendimento
                            // }

                            // let avaliacao_final_aux = 0                            
                            // for await (let el_1 of evaluating_criteria_types.current) {

                            //     if(el_aux.info.settings['evaluation_type_id_' + el_1.id]) {
                            //         avaliacao_final_aux += parseInt(el_1.value)
                            //     }

                            // }


                            // let classification_id_aux = ''
                            // let classification_name_aux = ''
                            // for await (let el_2 of evaluating_supply_quality_types.current) {

                            //     if(isNaN(parseInt(el_2.more))) {
                            //         if(parseInt(avaliacao_final_aux) >= parseInt(el_2.less)) {
                            //             classification_id_aux = el_2.id
                            //             classification_name_aux = el_2.label
                            //         }
                            //     }
                            //     else if(isNaN(parseInt(el_2.less))) {
                            //         if(parseInt(avaliacao_final_aux) < parseInt(el_2.more)) {
                            //             classification_id_aux = el_2.id
                            //             classification_name_aux = el_2.label
                            //         }
                            //     }
                            //     else {
                            //         if(parseInt(avaliacao_final_aux) >= parseInt(el_2.less) && parseInt(avaliacao_final_aux) < parseInt(el_2.more)) {
                            //             classification_id_aux = el_2.id
                            //             classification_name_aux = el_2.label
                            //         }
                            //     }

                            // }

                            // // console.log('------------------------------------------------------------')
                            // // console.log('avaliacao_final_aux', avaliacao_final_aux)
                            // // console.log('classification_id_aux', classification_id_aux)
                            // // console.log('classification_name_aux', classification_name_aux)
                            // // console.log('------------------------------------------------------------')

                            // el_aux.info.settings['avaliacao_final'] = avaliacao_final_aux
                            // el_aux.info.settings['classificacao'] = classification_name_aux
                            // el_aux.info.settings['classificacao_id'] = classification_id_aux

                            // // el_aux.info.settings['avaliacao_final'] = ''
                            // // el_aux.info.settings['classificacao'] = ''
                            // // el_aux.info.settings['classificacao_id'] = ''


                            // if(el_aux.info.settings.tipo !== undefined && el_aux.info.settings.tipo !== null) {
                            //     let x = evaluating_supply_types.current.filter(e => e.label === el_aux.info.settings.tipo)
                            //     if(Array.isArray(x) && x.length > 0) {
                            //         el_aux.info.settings['tipo_id'] = x[0].id

                            //         // await reqPUT(api_crud_route, el_aux)
                            //     }

                            // }


                    //         console.log('el_aux', el_aux)

                    //         await reqPUT(api_crud_route, el_aux)

                    //     }

                    // }
                    
                    set_dados(suppliers_list.current = res.data);

                    set_dados(suppliers_list.current = order_array_numero(res.data))

                    let aux = 0
                    let array_aux = []
                    let array_ano_aux = []
                    let array_name_aux = []
                    let array_tipo_aux = []
                    let array_month_aux = []

                    let avaliacao_total = 0

                    for await (let el of res.data) {

                        let aux_2 = array_ano_aux.filter(e => parseInt(e.info.name) === parseInt(el.info.settings.data.split('-')[2]))
                        if(Array.isArray(aux_2) && aux_2.length === 0) {
                            if(el.info.settings.data !== '') {
                                array_ano_aux.push({
                                    id: '',
                                    info: {
                                        name: el.info.settings.data.split('-')[2]
                                    }
                                })
                            }
                        }

                        let aux_3 = array_name_aux.filter(e => ((parseInt(e.info.year) === parseInt(el.info.settings.data.split('-')[2])) && (e.info.name.trim().replaceAll(" - ", "").toLowerCase() === el.info.settings.nome.trim().replaceAll(" - ", "").toLowerCase())))
                        if(Array.isArray(aux_3) && aux_3.length === 0) {
                            if(el.info.settings.nome.trim().replaceAll(" - ", "").toLowerCase() !== '') {
                                array_name_aux.push({
                                    id: Date.now(),
                                    info: {
                                        year: el.info.settings.data.split('-')[2],
                                        name: el.info.settings.nome,
                                        type: el.info.settings.tipo,
                                        type_id: el.info.settings.tipo_id,
                                        numero_fornecimentos: 1,
                                        numero_fornecimentos_avaliados: ((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true) ? 1 : 0),
                                        numero_fornecimentos_avaliados_valor_total: ((el.info.settings.avaliacao_final !== undefined && el.info.settings.avaliacao_final !== null && el.info.settings.avaliacao_final !== '') ? parseFloat(el.info.settings.avaliacao_final) : 0),
                                        classificacao: ((el.info.settings.classificacao !== undefined && el.info.settings.classificacao !== null && el.info.settings.classificacao !== '') ? el.info.settings.classificacao : ''),
                                        observacao: ''
                                    }
                                })
                            }
                        }
                        else {
                            array_name_aux.forEach(el_2 => {
                                if(el_2.info.name.trim().replaceAll(" - ", "").toLowerCase() === el.info.settings.nome.trim().replaceAll(" - ", "").toLowerCase()) {

                                    el_2.info.numero_fornecimentos = parseInt(el_2.info.numero_fornecimentos) + 1

                                    if((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true)) {
                                        el_2.info.numero_fornecimentos_avaliados = parseInt(el_2.info.numero_fornecimentos_avaliados) + 1

                                        if(!Number.isNaN(parseFloat(el.info.settings.avaliacao_final))) {
                                            el_2.info.numero_fornecimentos_avaliados_valor_total = parseFloat(el_2.info.numero_fornecimentos_avaliados_valor_total) + parseFloat(el.info.settings.avaliacao_final)
                                        }
                                    }
                                }
                            })
                        }

                        if(el.info.settings.tipo !== undefined) {
                            let aux_4 = array_tipo_aux.filter(e => (parseInt(e.info.year) === parseInt(el.info.settings.data.split('-')[2]) && (e.info.type.trim().replaceAll(" - ", "").toLowerCase() === el.info.settings.tipo.trim().replaceAll(" - ", "").toLowerCase())))
                            if(Array.isArray(aux_4) && aux_4.length === 0) {
                                if(el.info.settings.tipo.trim().replaceAll(" - ", "").toLowerCase() !== '') {

                                    array_tipo_aux.push({
                                        id: Date.now(),
                                        info: {
                                            year: el.info.settings.data.split('-')[2],
                                            type: el.info.settings.tipo,
                                            type_id: el.info.settings.tipo_id,
                                            numero_fornecimentos: 1,
                                            numero_fornecimentos_avaliados: ((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true) ? 1 : 0),
                                            numero_fornecimentos_avaliados_valor_total: ((el.info.settings.avaliacao_final !== undefined && el.info.settings.avaliacao_final !== null && el.info.settings.avaliacao_final !== '') ? parseFloat(el.info.settings.avaliacao_final) : 0),
                                            classificacao: ((el.info.settings.classificacao !== undefined && el.info.settings.classificacao !== null && el.info.settings.classificacao !== '') ? el.info.settings.classificacao : ''),
                                            observacao: ''
                                        }
                                    })
                                }
                            }
                            else {
                                array_tipo_aux.forEach(el_2 => {
                                    if(el_2.info.type.trim().replaceAll(" - ", "").toLowerCase() === el.info.settings.tipo.trim().replaceAll(" - ", "").toLowerCase()) {
                                        el_2.info.numero_fornecimentos = parseInt(el_2.info.numero_fornecimentos) + 1

                                        if((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true)) {
                                            el_2.info.numero_fornecimentos_avaliados = parseInt(el_2.info.numero_fornecimentos_avaliados) + 1

                                            if(!Number.isNaN(parseFloat(el.info.settings.avaliacao_final))) {
                                                el_2.info.numero_fornecimentos_avaliados_valor_total = parseFloat(el_2.info.numero_fornecimentos_avaliados_valor_total) + parseFloat(el.info.settings.avaliacao_final)
                                            }
                                        }

                                    }
                                })
                            }
                        }

                    }

                    set_dados(years_actives.current = array_ano_aux)
                    set_dados(suppliers_list_by_name_active.current = array_name_aux)
                    set_dados(suppliers_list_by_tipo_active.current = array_tipo_aux)

                    // console.log('suppliers_list_by_name_active.current', suppliers_list_by_name_active.current)
                    // console.log('suppliers_list_by_tipo_active.current', suppliers_list_by_tipo_active.current)

                    if(Array.isArray(array_ano_aux) && array_ano_aux.length > 0) {
                        set_dados(year_active.current = array_ano_aux[0].info.name)

                        if(array_ano_aux[0]?.info?.name !== undefined && array_ano_aux[0]?.info?.name !== null && array_ano_aux[0].info.name !== '') {
                            if(!_loading_) {
                                change_year(year_active.current)
                            }
                        }
                    }

                }
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {
		
		    set_dados(entities_list.current = [])
            set_dados(year_active.current = '')

			await get_attr()

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_state = (element) => {

        let result = '<span className="badge rounded-0 bg-light text-dark p-3 fs-6">' + language[lang].action_not_open + '</span>'

        if(element?.info?.action?.analysis?.ac_am !== undefined) {

            if(element.info.action.analysis.ac_am === true) {

                if(element?.info?.action?.results?.responsable?.execution !== undefined && element?.info?.action?.results?.responsable?.execution !== null && element.info.action.results.responsable.execution !== '') {
                    if(element?.info?.action?.results?.value !== undefined && parseInt(element.info.action.results.value) === 1) {
                        result = '<span className="badge rounded-0 bg-success p-3 fs-6">' + language[lang].effective + '</span>'
                    }
                    else if(element?.info?.action?.results?.value !== undefined && element?.info?.action?.results?.value !== null && parseInt(element.info.action.results.value) === 0) {
                        result = '<span className="badge rounded-0 bg-danger p-3 fs-6">' + language[lang].not_effective + '</span>'
                    }
                }
                else if(element?.info?.action?.improvement?.responsable?.execution !== undefined && element?.info?.action?.improvement?.responsable?.execution !== null && element.info.action.improvement.responsable.execution !== '') {
                    result = '<span className="badge rounded-0 bg-warning text-dark p-3 fs-6">' + language[lang].for_evaluating + '</span>'
                }
                else {
                    result = '<span className="badge rounded-0 bg-orange text-dark p-3 fs-6">' + language[lang].action_to_be_taken + '</span>'
                }

            }
        }

        return result
    }
    
    const columns = [
        {
            name: language[lang].field_number,
            selector: 'info.number',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_type,
            selector: 'info.settings.occurrence_type',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_date,
            selector: 'info.action.identification.notification',
            cell: row => (
                row?.info?.action?.identification?.responsable?.notification !== undefined && row.info.action.identification.responsable.notification !== '' ? row.info.action.identification.responsable.notification.split('T')[0] : ''
            ),
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_name,
            selector: 'info.name',
            width: '45% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_state,
            cell: row => (
                parse(get_state(row))
            ),
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        Array.isArray(row.info.file.pdf) && row.info.file.pdf.length > 0 ?
                            <a className="button button-update button-view p-0 pe-2" href={row.info.file.pdf[row.info.file.pdf.length - 1].link} target='_blank'>
                                <i className="bi bi-eye"></i>
                            </a>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const add_new_year = async () => {


        const { value: year } = await Swal.fire({
            input: "text",
            inputLabel: "Ano",
            inputPlaceholder: "Inserir o ano"
        });

        if (year !== '') {
            if(!Array.isArray(years_actives.current)) {
                years_actives.current = []
            }

            set_dados(new_year.current = year)
            set_dados(year_active.current = year)

            set_dados(years_actives.current.push({
                id: '',
                info: {
                    name: year
                }
            }))

//             change_year(year)

            setRefresh(r => r + 1)

        }


        /*
        if(years_actives.current !== undefined && years_actives.current !== null && years_actives.current.length > 0) {

            let last_year = years_actives.current[years_actives.current.length - 1]
            let aux_year = parseInt(last_year.info.name) + 1
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            set_dados(years_actives.current.push({
                id: '',
                info: {
                    name: aux_year
                }
            }))

            change_year(aux_year)

        }
        else {
            let aux_year = new Date().getFullYear()
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            let aux = {
                id: '',
                info: {
                name: aux_year
            }
            }

            set_dados(years_actives.current = [aux])

            change_year(aux_year)
        }

        */
    }

    const change_year = async (year) => {

        console.log('set_loading_ true')
        set_loading_(true)

        if(suppliers_list.current !== undefined && suppliers_list.current !== null && suppliers_list.current.length > 0) {

            set_dados(total_fonecimentos.current = 0)
            set_dados(total_fonecimentos_avaliados.current = 0)

            set_dados(total_ocorrencias_list.current = [])

            let aux = []
            let array_name_aux = []
            let array_tipo_aux = []
            let array_tipo_classificacao_aux = []
            let array_classificacao_aux = []
            let array_classificacao_tipo_prod_aux = []
            let array_classificacao_tipo_prod_2_aux = []
            let array_month_aux = []
            for await (let el of suppliers_list.current) {
                if(el.info.settings.data.split('-')[2].toString() === year.toString()) {    
                    aux.push(el)        

                    let aux_3 = array_name_aux.filter(e => ((parseInt(e.info.year) === parseInt(el.info.settings.data.split('-')[2])) && (e.info.name.trim().replaceAll(" - ", "").toLowerCase() === el.info.settings.nome.trim().replaceAll(" - ", "").toLowerCase())))
                    if(Array.isArray(aux_3) && aux_3.length === 0) {
                        if(el.info.settings.nome.trim().replaceAll(" - ", "").toLowerCase() !== '') {
                            array_name_aux.push({
                                id: Date.now(),
                                info: {
                                    year: el.info.settings.data.split('-')[2],
                                    name: el.info.settings.nome,
                                    type: el.info.settings.tipo,
                                    type_id: el.info.settings.tipo_id,
                                    numero_fornecimentos: 1,
                                    numero_fornecimentos_avaliados: ((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true) ? 1 : 0),
                                    numero_fornecimentos_avaliados_valor_total: ((el.info.settings.avaliacao_final !== undefined && el.info.settings.avaliacao_final !== null && el.info.settings.avaliacao_final !== '') ? parseFloat(el.info.settings.avaliacao_final) : 0),
                                    classificacao: ((el.info.settings.classificacao !== undefined && el.info.settings.classificacao !== null && el.info.settings.classificacao !== '') ? el.info.settings.classificacao : ''),
                                    observacao: ''
                                }
                            })
                        }
                    }
                    else {
                        array_name_aux.forEach(el_2 => {
                            if(el_2.info.name.trim().replaceAll(" - ", "").toLowerCase() === el.info.settings.nome.trim().replaceAll(" - ", "").toLowerCase()) {

                                el_2.info.numero_fornecimentos = parseInt(el_2.info.numero_fornecimentos) + 1

                                if((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true)) {
                                    el_2.info.numero_fornecimentos_avaliados = parseInt(el_2.info.numero_fornecimentos_avaliados) + 1

                                    if(!Number.isNaN(parseFloat(el.info.settings.avaliacao_final))) {
                                        el_2.info.numero_fornecimentos_avaliados_valor_total = parseFloat(el_2.info.numero_fornecimentos_avaliados_valor_total) + parseFloat(el.info.settings.avaliacao_final)
                                    }
                                }

                            }
                        })
                    }

                    if(el.info.settings.tipo_id !== undefined) {
                        let aux_4 = array_tipo_aux.filter(e => (parseInt(e.info.year) === parseInt(el.info.settings.data.split('-')[2]) && (parseInt(e.info.type_id) === parseInt(el.info.settings.tipo_id))))
                        if(Array.isArray(aux_4) && aux_4.length === 0) {
                            if(el.info.settings.tipo_id !== '') {
                                array_tipo_aux.push({
                                    id: Date.now(),
                                    info: {
                                        year: el.info.settings.data.split('-')[2],
                                        type: el.info.settings.tipo,
                                        type_id: el.info.settings.tipo_id,
                                        classificacao: el.info.settings.classificacao,
                                        classificacao_id: el.info.settings.classificacao_id,
                                        numero_fornecimentos: 1,
                                        numero_fornecimentos_avaliados: ((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true) ? 1 : 0),
                                        numero_fornecimentos_avaliados_valor_total: ((el.info.settings.avaliacao_final !== undefined && el.info.settings.avaliacao_final !== null && el.info.settings.avaliacao_final !== '') ? parseFloat(el.info.settings.avaliacao_final) : 0),
                                        classificacao: ((el.info.settings.classificacao !== undefined && el.info.settings.classificacao !== null && el.info.settings.classificacao !== '') ? el.info.settings.classificacao : ''),
                                        observacao: ''
                                    }
                                })
                            }
                        }
                        else {
                            array_tipo_aux.forEach(el_2 => {
                                if(parseInt(el_2.info.type_id) === parseInt(el.info.settings.tipo_id)) {
                                    el_2.info.numero_fornecimentos = parseInt(el_2.info.numero_fornecimentos) + 1

                                    if((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true)) {
                                        el_2.info.numero_fornecimentos_avaliados = parseInt(el_2.info.numero_fornecimentos_avaliados) + 1

                                        if(!Number.isNaN(parseFloat(el.info.settings.avaliacao_final))) {
                                            el_2.info.numero_fornecimentos_avaliados_valor_total = parseFloat(el_2.info.numero_fornecimentos_avaliados_valor_total) + parseFloat(el.info.settings.avaliacao_final)
                                        }
                                    }

                                }
                            })
                        }
                    }

                    if(el.info.settings.tipo_id !== undefined) {

                        let aux_8 = array_tipo_classificacao_aux.filter(e => (parseInt(e.info.year) === parseInt(el.info.settings.data.split('-')[2]) && (parseInt(e.info.type_id) === parseInt(el.info.settings.tipo_id)) && (parseInt(e.info.classificacao_id) === parseInt(el.info.settings.classificacao_id)) ))
                        if(Array.isArray(aux_8) && aux_8.length === 0) {
                            if(el.info.settings.tipo_id !== '') {
                                array_tipo_classificacao_aux.push({
                                    id: Date.now(),
                                    info: {
                                        year: el.info.settings.data.split('-')[2],
                                        type: el.info.settings.tipo,
                                        type_id: el.info.settings.tipo_id,
                                        avaliado: el.info.settings.avaliado,
                                        classificacao: el.info.settings.classificacao,
                                        classificacao_id: el.info.settings.classificacao_id,
                                        numero_fornecimentos: 1,
                                        numero_fornecimentos_avaliados: ((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true) ? 1 : 0),
                                        numero_fornecimentos_avaliados_valor_total: ((el.info.settings.avaliacao_final !== undefined && el.info.settings.avaliacao_final !== null && el.info.settings.avaliacao_final !== '') ? parseFloat(el.info.settings.avaliacao_final) : 0),
                                        classificacao: ((el.info.settings.classificacao !== undefined && el.info.settings.classificacao !== null && el.info.settings.classificacao !== '') ? el.info.settings.classificacao : ''),
                                        observacao: ''
                                    }
                                })
                            }
                        }
                        else {
                            array_tipo_classificacao_aux.forEach(el_2 => {
                                if(parseInt(el_2.info.type_id) === parseInt(el.info.settings.tipo_id) && (parseInt(el_2.info.classificacao_id) === parseInt(el.info.settings.classificacao_id))) {
                                    el_2.info.numero_fornecimentos = parseInt(el_2.info.numero_fornecimentos) + 1

                                    if((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true)) {
                                        el_2.info.numero_fornecimentos_avaliados = parseInt(el_2.info.numero_fornecimentos_avaliados) + 1

                                        if(!Number.isNaN(parseFloat(el.info.settings.avaliacao_final))) {
                                            el_2.info.numero_fornecimentos_avaliados_valor_total = parseFloat(el_2.info.numero_fornecimentos_avaliados_valor_total) + parseFloat(el.info.settings.avaliacao_final)
                                        }
                                    }

                                }
                            })
                        }
                    }

                    let aux_5 = array_month_aux.filter(e => ((parseInt(e.info.year) === parseInt(el.info.settings.data.split('-')[2])) && (parseInt(e.info.month) === parseInt(el.info.settings.data.split('-')[1]))))
                    if(Array.isArray(aux_5) && aux_5.length === 0) {
                        if(el.info.settings.data.split('-')[1] !== '') {
                            let aux = {
                                id: Date.now(),
                                info: {
                                    year: el.info.settings.data.split('-')[2],
                                    month: el.info.settings.data.split('-')[1],
                                    numero_fornecimentos: 1,
                                    numero_fornecimentos_avaliados: ((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true) ? 1 : 0),
                                }
                            }

                            if(el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true && evaluating_criteria_types.current !== undefined) {
                                evaluating_criteria_types.current.forEach((el_ect) => {
                                    aux.info['evaluation_type_id_' + el_ect.id] = (((el.info.settings['evaluation_type_id_' + el_ect.id] === undefined || el.info.settings['evaluation_type_id_' + el_ect.id] === null || el.info.settings['evaluation_type_id_' + el_ect.id] === '' || el.info.settings['evaluation_type_id_' + el_ect.id] === false)) ? 1 : 0)
                                })

                            }

                            array_month_aux.push(aux)

                            set_dados(total_fonecimentos.current = total_fonecimentos.current + 1)
                            set_dados(total_fonecimentos_avaliados.current = total_fonecimentos_avaliados.current + parseInt((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true) ? 1 : 0))

                        }
                    }
                    else {
                        array_month_aux.forEach(el_2 => {
                            if(parseInt(el_2.info.month) === parseInt(el.info.settings.data.split('-')[1])) {

                                el_2.info.numero_fornecimentos = parseInt(el_2.info.numero_fornecimentos) + 1

                                set_dados(total_fonecimentos.current = total_fonecimentos.current + 1)

                                if((el.info.settings.avaliado !== undefined && el.info.settings.avaliado !== null && el.info.settings.avaliado === true)) {
                                    el_2.info.numero_fornecimentos_avaliados = parseInt(el_2.info.numero_fornecimentos_avaliados) + 1

                                    set_dados(total_fonecimentos_avaliados.current = total_fonecimentos_avaliados.current + 1)

                                    if(evaluating_criteria_types.current !== undefined) {
                                        evaluating_criteria_types.current.forEach((el_ect) => {
                                            if(el.info.settings['evaluation_type_id_' + el_ect.id] === undefined || el.info.settings['evaluation_type_id_' + el_ect.id] === null || el.info.settings['evaluation_type_id_' + el_ect.id] === '' || el.info.settings['evaluation_type_id_' + el_ect.id] === false) {
                                                if(el_2.info['evaluation_type_id_' + el_ect.id] === undefined || el_2.info['evaluation_type_id_' + el_ect.id] === null) {
                                                    el_2.info['evaluation_type_id_' + el_ect.id] = 1
                                                }
                                                else {
                                                    el_2.info['evaluation_type_id_' + el_ect.id] = parseInt(el_2.info['evaluation_type_id_' + el_ect.id]) + 1
                                                }
                                            }
                                            else {
                                                if(el_2.info['evaluation_type_id_' + el_ect.id] === undefined || el_2.info['evaluation_type_id_' + el_ect.id] === null) {
                                                    el_2.info['evaluation_type_id_' + el_ect.id] = 0
                                                }
                                            }                                            
                                        })
                                    }
                                }

                            }
                        })
                    }
                }
            }

            set_dados(suppliers_list_active.current = aux)
            set_dados(suppliers_list_by_name_active.current = array_name_aux)
            set_dados(suppliers_list_by_tipo_active.current = array_tipo_aux)



            // console.log('3 ---->', ((array_tipo_classificacao_aux)))
            set_dados(suppliers_list_by_tipo_classificacao_active.current = array_tipo_classificacao_aux)
            set_dados(suppliers_list_by_month_active.current = array_month_aux)

            for await (let el_ of suppliers_list_by_name_active.current) {
                for await (let el_2 of evaluating_supplier_types.current) {
                    if(parseInt(el_.info.year) === parseInt(year)) {

                        let value = 0.0
                        if(parseInt(el_.info.numero_fornecimentos_avaliados) > 0) {
                            value = parseInt(el_.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_.info.numero_fornecimentos_avaliados)
                        }

                        if(isNaN(parseInt(el_2.more))) {
                            if(parseInt(value) >= parseInt(el_2.less)) {
                                
                                let aux_6 = array_classificacao_aux.filter(e => ((parseInt(e.info.year) === parseInt(year)) && (e.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase())))
                                if(Array.isArray(aux_6) && aux_6.length === 0) {
                                    if(el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() !== '') {
                                        array_classificacao_aux.push({
                                            id: Date.now(),
                                            info: {
                                                year: year,
                                                classificacao_id: el_2.id,
                                                classificacao: el_.info.classificacao,
                                                numero_fornecedores: 1,
                                            }
                                        })
                                    }
                                }
                                else {
                                    array_classificacao_aux.forEach(el_3 => {                                        
                                        if(el_3.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase()) {

                                            el_3.info.numero_fornecedores = parseInt(el_3.info.numero_fornecedores) + 1

                                        }
                                    })
                                }
                                
                            }
                        }
                        else if(isNaN(parseInt(el_2.less))) {
                            if(parseInt(value) < parseInt(el_2.more)) {
                                
                                let aux_6 = array_classificacao_aux.filter(e => ((parseInt(e.info.year) === parseInt(year)) && (e.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase())))
                                if(Array.isArray(aux_6) && aux_6.length === 0) {
                                    if(el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() !== '') {
                                        array_classificacao_aux.push({
                                            id: Date.now(),
                                            info: {
                                                year: year,
                                                classificacao_id: el_2.id,
                                                classificacao: el_.info.classificacao,
                                                numero_fornecedores: 1,
                                            }
                                        })
                                    }
                                }
                                else {
                                    array_classificacao_aux.forEach(el_3 => {                                        
                                        if(el_3.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase()) {

                                            el_3.info.numero_fornecedores = parseInt(el_3.info.numero_fornecedores) + 1

                                        }
                                    })
                                }

                            }
                        }
                        else {
                            if(parseInt(value) >= parseInt(el_2.less) && parseInt(value) < parseInt(el_2.more)) {
                                
                                let aux_6 = array_classificacao_aux.filter(e => ((parseInt(e.info.year) === parseInt(year)) && (e.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase())))
                                if(Array.isArray(aux_6) && aux_6.length === 0) {
                                    if(el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() !== '') {
                                        array_classificacao_aux.push({
                                            id: Date.now(),
                                            info: {
                                                year: year,
                                                classificacao_id: el_2.id,
                                                classificacao: el_.info.classificacao,
                                                numero_fornecedores: 1,
                                            }
                                        })
                                    }
                                }
                                else {
                                    array_classificacao_aux.forEach(el_3 => {                                        
                                        if(el_3.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase()) {

                                            el_3.info.numero_fornecedores = parseInt(el_3.info.numero_fornecedores) + 1

                                        }
                                    })
                                }

                            }
                        }

                    }

                }
            }
            set_dados(suppliers_list_by_classificacao_active.current = array_classificacao_aux)

            for await (let el_ of suppliers_list_by_tipo_active.current) {
                for await (let el_2 of evaluating_supplier_types.current) {
                    if(parseInt(el_.info.year) === parseInt(year)) {

                        let aux_7 = array_classificacao_tipo_prod_aux.filter(e => ((parseInt(e.info.year) === parseInt(year)) && (parseInt(e.info.type_id) === parseInt(el_.info.type_id))) && (e.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase()))
                        if(Array.isArray(aux_7) && aux_7.length === 0) {
                            if(el_.info.type_id !== '' && el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() !== '') {
                                array_classificacao_tipo_prod_aux.push({
                                    id: Date.now(),
                                    info: {
                                        year: year,
                                        type: el_.info.type,
                                        type_id: el_.info.type_id,
                                        classificacao_id: el_.info.classificacao_id,
                                        classificacao: el_.info.classificacao,
                                        numero_fornecimentos: el_.info.numero_fornecimentos,
                                        numero_fornecimentos_avaliados:  el_.info.numero_fornecimentos_avaliados,
                                        numero_fornecimentos_avaliados_valor_total: el_.info.numero_fornecimentos_avaliados_valor_total
                                    }
                                })
                            }
                        }
                        else {
                            array_classificacao_tipo_prod_aux.forEach(el_3 => {    
                                if(parseInt(el_3.info.type_id) === parseInt(el_.info.type_id) && el_3.info.classificacao.trim().replaceAll(" - ", "").toLowerCase() === el_.info.classificacao.trim().replaceAll(" - ", "").toLowerCase()) {

                                    el_3.info.numero_fornecimentos = parseInt(el_3.info.numero_fornecimentos) + parseInt(el_.info.numero_fornecimentos)
                                    el_3.info.numero_fornecimentos_avaliados = parseInt(el_3.info.numero_fornecimentos_avaliados) + parseInt(el_.info.numero_fornecimentos_avaliados)

                                }
                            })
                        }
                               

                    }

                }
            }
            set_dados(suppliers_list_by_classificacao_tipo_prod_active.current = array_classificacao_tipo_prod_aux)

            for await (let el_ of suppliers_list_by_tipo_classificacao_active.current) {
                // for await (let el_2 of evaluating_supplier_types.current) {
                    if(parseInt(el_.info.year) === parseInt(year)) {

                        let aux_8 = array_classificacao_tipo_prod_2_aux.filter(e => ((parseInt(e.info.year) === parseInt(year)) && (parseInt(e.info.type_id) === parseInt(el_.info.type_id))) && (parseInt(e.info.classificacao_id) === parseInt(el_.info.classificacao_id)))
                        if(Array.isArray(aux_8) && aux_8.length === 0) {
                            if(el_.info.type_id !== '') {
                                array_classificacao_tipo_prod_2_aux.push({
                                    id: Date.now(),
                                    info: {
                                        year: year,
                                        type: el_.info.type,
                                        type_id: el_.info.type_id,
                                        classificacao_id: el_.info.classificacao_id,
                                        classificacao: el_.info.classificacao,
                                        numero_fornecimentos: el_.info.numero_fornecimentos,
                                        numero_fornecimentos_avaliados:  el_.info.numero_fornecimentos_avaliados,
                                        numero_fornecimentos_avaliados_valor_total: el_.info.numero_fornecimentos_avaliados_valor_total
                                    }
                                })
                            }
                        }
                        else {
                            array_classificacao_tipo_prod_2_aux.forEach(el_3 => {    
                                if(parseInt(el_3.info.type_id) === parseInt(el_.info.type_id) && parseInt(el_3.info.classificacao_id) === parseInt(el_.info.classificacao_id)) {

                                    el_3.info.numero_fornecimentos = parseInt(el_3.info.numero_fornecimentos) + parseInt(el_.info.numero_fornecimentos)
                                    el_3.info.numero_fornecimentos_avaliados = parseInt(el_3.info.numero_fornecimentos_avaliados) + parseInt(el_.info.numero_fornecimentos_avaliados)

                                }
                            })
                        }
                               
                    }

                // }
            }
            set_dados(suppliers_list_by_classificacao_tipo_prod_2_active.current = array_classificacao_tipo_prod_2_aux)

            set_dados(total_tx_avaliados.current = (parseInt(total_fonecimentos_avaliados.current) * 100 / parseInt(total_fonecimentos.current)).toFixed(1))
        }
        else {
            
        }

        set_dados(year_active.current = year)
        set_show_table(0)

        set_loading_(false)
        console.log('set_loading_ false')

    }


    const add_row = () => {

        console.log('add_row')

        set_dados(new_row.current = {
                id: '',
                info: {
                    companycode: getTokenInfo().companycode,
                    type: 'intranet_supplier',
                    settings: {}
                }
            })

    }

	const change_settings_new_row = (e) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset
		
		if (new_row.current === undefined) {
			new_row.current = {
                id: '',
                info: {
                    companycode: getTokenInfo().companycode,
                    settings: {}
                }
            }
		}

        if(name === 'nome') {
            if (new_row.current.info.settings.entity === undefined) {
                new_row.current.info.settings.entity = {}
            }

            let x = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
            if(Array.isArray(x) && x.length > 0) {
                let aux = {
                    id: x[0].id,
                    name: x[0].label
                } 

                set_dados(new_row.current.info.settings.nome = x[0].label)
                set_dados(new_row.current.info.name = x[0].label)
                set_dados(new_row.current.info.settings.entity = aux)
            }
        }
        else if(value === 'true') {
            set_dados(new_row.current.info.settings[name] = true)
        }
        else if(value === 'false') {
            set_dados(new_row.current.info.settings[name] = false)
            
        }
        else if(name === 'data') {
            let d = value.split('-')
            set_dados(new_row.current.info.settings[name] = d[2] + '-' + d[1] + '-' + d[0])
        }
        else if(name === 'tipo_id') {
            let aux = evaluating_supply_types.current.filter(e => parseInt(e.id) === parseInt(value))
            if(Array.isArray(aux) && aux.length > 0) {
                set_dados(new_row.current.info.settings['tipo'] = aux[0].label)
                set_dados(new_row.current.info.settings[name] = false)
            }
        }
        else {
            set_dados(new_row.current.info.settings[name] = value)
        }

		setRefresh(r => r + 1)

		console.log('new_row.current', new_row.current)

	}

    const save_row = async () => {

        supplier_active.current = new_row.current


        let avaliacao_final_aux = 0
        for await (let el_1 of evaluating_criteria_types.current) {

            if(supplier_active.current.info.settings['evaluation_type_id_' + el_1.id]) {
                avaliacao_final_aux += parseInt(el_1.value)
            }

        }

        let classification_id_aux = ''
        let classification_name_aux = ''

        for await (let el_2 of evaluating_supply_quality_types.current) {

            if(isNaN(parseInt(el_2.more))) {
                if(parseInt(avaliacao_final_aux) >= parseInt(el_2.less)) {
                    classification_id_aux = el_2.id
                    classification_name_aux = el_2.label
                }
            }
            else if(isNaN(parseInt(el_2.less))) {
                if(parseInt(avaliacao_final_aux) < parseInt(el_2.more)) {
                    classification_id_aux = el_2.id
                    classification_name_aux = el_2.label
                }
            }
            else {
                if(parseInt(avaliacao_final_aux) >= parseInt(el_2.less) && parseInt(avaliacao_final_aux) < parseInt(el_2.more)) {
                    classification_id_aux = el_2.id
                    classification_name_aux = el_2.label
                }
            }

        }

        supplier_active.current.info.settings['avaliacao_final'] = avaliacao_final_aux
        supplier_active.current.info.settings['classificacao'] = classification_name_aux
        supplier_active.current.info.settings['classificacao_id'] = classification_id_aux

        if(supplier_active.current.id === '') {
            await reqPOST(api_crud_route, supplier_active.current)
        }
        else {
            await reqPUT(api_crud_route, supplier_active.current)
        }

        let aux = await reqGET(api_list_route(getTokenInfo().companycode))
        set_dados(suppliers_list_active.current = aux)
        set_dados(new_row.current = [])

        setRefresh(r => r + 1)

    }

    const edit_row = async (el) => {

        set_dados(supplier_active.current = el)
        // let aux = []
        // aux.push(el)
        // set_dados(active_row.current = aux)
        set_dados(new_row.current = el.info.settings)

        console.log('supplier_active.current', supplier_active.current)
        console.log('active_row.current', active_row.current)


    }

    const get_month_name = (id) => {

        let result = ''
        months_list.forEach(el => {
            if(parseInt(el.id) === parseInt(id)) {
                result = el.name
            }
        })
        return result

    }

    const get_supply_quality_type = (value) => {

        let result = ''
        evaluating_supply_quality_types.current.forEach(el_2 => {

            if(isNaN(parseInt(el_2.more))) {
                if(parseInt(value) >= parseInt(el_2.less)) {
                    result = el_2.label
                }
            }
            else if(isNaN(parseInt(el_2.less))) {
                if(parseInt(value) < parseInt(el_2.more)) {
                    result = el_2.label
                }
            }
            else {
                if(parseInt(value) >= parseInt(el_2.less) && parseInt(value) < parseInt(el_2.more)) {
                    result = el_2.label
                }
            }

        })

        return result

    }

    const get_supply_type = (id) => {

        let result = ''
        evaluating_supply_types.current.forEach(el_2 => {
            if(parseInt(el_2.id) === parseInt(id))
            result = el_2.label
        })

        return result

    }

    const get_supply_type_name = (id) => {

        let result = ''
        evaluating_supply_quality_types.current.forEach(el_2 => {
            if(parseInt(el_2.id) === parseInt(id))
            result = el_2.label
        })

        return result

    }

    const get_supplier_type_name = (id) => {

        let result = ''
        evaluating_supplier_types.current.forEach(el_2 => {
            if(parseInt(el_2.id) === parseInt(id))
            result = el_2.label
        })

        return result

    }

    const get_supplier_type = (value) => {

        let result = ''
        evaluating_supplier_types.current.forEach(el_2 => {

            if(isNaN(parseInt(el_2.more))) {
                if(parseInt(value) >= parseInt(el_2.less)) {
                    result = el_2.label
                }
            }
            else if(isNaN(parseInt(el_2.less))) {
                if(parseInt(value) < parseInt(el_2.more)) {
                    result = el_2.label
                }
            }
            else {
                if(parseInt(value) >= parseInt(el_2.less) && parseInt(value) < parseInt(el_2.more)) {
                    result = el_2.label
                }
            }

        })

        return result

    }

    const get_supplier_obs = (value) => {

        let result = ''
        evaluating_supplier_types.current.forEach(el_2 => {

            if(isNaN(parseInt(el_2.more))) {
                if(parseInt(value) >= parseInt(el_2.less)) {
                    // result = el_2.obs
                    // result = 'Não requer ações de melhoria'
                    result = el_2.warning
                }
            }
            else if(isNaN(parseInt(el_2.less))) {
                if(parseInt(value) < parseInt(el_2.more)) {
                    // result = el_2.obs
                    // result = 'Retirar fornecedor da lista de fornecedores aceites'
                    result = el_2.warning
                }
            }
            else {
                if(parseInt(value) >= parseInt(el_2.less) && parseInt(value) < parseInt(el_2.more)) {
                    // result = el_2.obs
                    // result = 'Requer ações de melhoria'
                    result = el_2.warning
                }
            }

        })

        return result

    }

    const get_supplier_accepted = (value) => {

        let result = ''
        evaluating_supplier_types.current.forEach(el_2 => {

            if(isNaN(parseInt(el_2.more))) {
                if(parseInt(value) >= parseInt(el_2.less)) {
                    result = 'Fornecedor aceite'
                }
            }
            else if(isNaN(parseInt(el_2.less))) {
                if(parseInt(value) < parseInt(el_2.more)) {
                    result = 'Fornecedor não aceite'
                }
            }
            else {
                if(parseInt(value) >= parseInt(el_2.less) && parseInt(value) < parseInt(el_2.more)) {
                    result = 'Requer melhorias'
                }
            }

        })

        return result

    }

    return (isloading ?

        <Loader />

    :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8">
                                    </div>
                                    <div className="table-body suppliers-list">
 
                                        <div className="row">
                                            <div className="col-6 mb-3 d-flex">
                                                {
                                                years_actives.current !== undefined && years_actives.current !== null ?
                                                    years_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el.info.name) === parseInt(year_active.current) ? ' active' : '' )} onClick={() => change_year(dt_el.info.name)} >{dt_el.info.name}</button>
                                                            </div>
                                                        )
                                                    })
                                                :
                                                    null
                                                }
                                                <div>
                                                    <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2 d-none"} onClick={() => add_new_year()} ><i className="bi bi-plus"></i> {language[lang].add_new_year}</button>
                                                </div>
                                            </div>
                                                
                                            <div className='col-6 text-end'>
                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill" + (parseInt(show_table) === 0 ? '' : ' d-none')} data-bs-toggle="modal" data-bs-target={"#insert_modal"} onClick={() => add_row()}>{language[lang].add_new}</button>
                                            </div>

                                            <div className="col-12 mb-3">
                                                {
                                                year_active?.current !== undefined && year_active?.current !== null && year_active.current.name !== '' && 
                                                suppliers_list_active?.current !== undefined && suppliers_list_active?.current !== null && suppliers_list_active.current.length > 0 ?
                                                    <div className="row">

                                                        <div className="div-table">
                                                            <div className="table-header text-end mb-8">
                                                            </div>
                                                            <div className="table-body suppliers-list">
                                                                <div className="row">

                                                                    {console.log('_loading_', _loading_)}
                                                                    {
                                                                    _loading_ ?
                                                                        <div className="overlay" style={{zIndex: '90'}}>
                                                                            <div className="overlay__inner">
                                                                                <div className="overlay__content">
                                                                                    <span className="spinner"></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    :
                                                                        null
                                                                    }

                                                                    <div className='col-12 text-end'>
                                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill mt-4 mb-4 ms-2" + (parseInt(show_table) === 0 ? ' active' : '')} onClick={() => set_show_table(0)}>{language[lang].field_review_register}</button>
                                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill mt-4 mb-4 ms-2" + (parseInt(show_table) === 1 ? ' active' : '')} onClick={() => set_show_table(1)}>{language[lang].field_review_by_supplier}</button>
                                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill mt-4 mb-4 ms-2" + (parseInt(show_table) === 2 ? ' active' : '')} onClick={() => set_show_table(2)}>{language[lang].field_review_by_supply_type}</button>
                                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill mt-4 mb-4 ms-2" + (parseInt(show_table) === 4 ? ' active' : '')} onClick={() => set_show_table(4)}>{language[lang].field_list_accepted_suppliers}</button>
                                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill mt-4 mb-4 ms-2" + (parseInt(show_table) === 3 ? ' active' : '')} onClick={() => set_show_table(3)}>{language[lang].field_monthly_statistics}</button>
                                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill mt-4 mb-4 ms-2" + (parseInt(show_table) === 5 ? ' active' : '')} onClick={() => set_show_table(5)}>{language[lang].field_statistical_data}</button>
                                                                    </div>

                                                                    <div className="col-12 mb-3">
                                                                        <div className="mb-5"> 
                                                                            <div className={"div-table" + (parseInt(show_table) === 0 ? '' : ' d-none')}>
                                                                                <div className="table-body suppliers-list scroll table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr className="text-white">
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].table_date}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplier}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supply_type}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supply_evaluated}</th>
                                                                                                {
                                                                                                evaluating_criteria_types.current !== undefined ?
                                                                                                    evaluating_criteria_types.current.map((el_ect, k_ect) => {
                                                                                                        return (
                                                                                                            <th key={k_ect} className="text-white">{el_ect.label}</th>
                                                                                                        )
                                                                                                    })
                                                                                                :
                                                                                                    null
                                                                                                }
                                                                                                <th className="text-white p-3">{language[lang].field_final_evaluation}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_classification}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            suppliers_list_active.current.map((el_fla, k_fla) => {
                                                                                                return (
                                                                                                    <tr key={k_fla}>
                                                                                                        <td>
                                                                                                            <div className="text-nowrap text-end">
                                                                                                                <span style={{
                                                                                                                    fontFamily: 'monospace',
                                                                                                                    fontVariantNumeric: 'tabular-nums',
                                                                                                                }}>
                                                                                                                    {el_fla.info.settings.numero}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            <div className="text-nowrap">
                                                                                                                <span style={{
                                                                                                                    fontFamily: 'monospace',
                                                                                                                    fontVariantNumeric: 'tabular-nums',
                                                                                                                }}>
                                                                                                                    {el_fla.info.settings.data}

                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td><div className="text-nowrap">{el_fla.info.settings.nome}</div></td>
                                                                                                        <td><div className="text-nowrap">{get_supply_type(el_fla.info.settings.tipo_id)}</div></td>
                                                                                                        <td><div className="text-center">{el_fla.info.settings.avaliado ? 'Sim' : 'Não'}</div></td>
                                                                                                        {
                                                                                                        evaluating_criteria_types.current !== undefined ?
                                                                                                            evaluating_criteria_types.current.map((el_ect, k_ect) => {
                                                                                                                return (
                                                                                                                    <td key={k_ect}><div className={"text-center"}>{el_fla.info.settings['evaluation_type_id_' + el_ect.id] === true ? 'X' : ''}</div></td>
                                                                                                                )
                                                                                                            })
                                                                                                        :
                                                                                                            null
                                                                                                        }
                                                                                                        <td><div className="text-center">{el_fla.info.settings.avaliacao_final}</div></td>
                                                                                                        <td><div className="text-nowrap">{el_fla.info.settings.classificacao}</div></td>
                                                                                                    </tr>
                                                                                                )
                                                                                            })
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>

                                                                            <div className={"div-table" + (parseInt(show_table) === 1 ? '' : ' d-none')}>
                                                                                <div className="table-body scroll table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr className="text-white">
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplier}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supply_type}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_supplies}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_supplies_evaluated}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_rating_average}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplier_classification}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_request_improvement}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            suppliers_list_by_name_active.current !== undefined && suppliers_list_by_name_active.current !== null ?
                                                                                                suppliers_list_by_name_active.current.map((el_fla, k_fla) => {
                                                                                                    return (
                                                                                                        <tr key={k_fla}>
                                                                                                            <th><div className="text-nowrap text-end">{parseInt(k_fla + 1)}</div></th>
                                                                                                            <th><div className="text-nowrap">{el_fla.info.name}</div></th>
                                                                                                            <th><div className="text-nowrap">{get_supply_type(el_fla.info.type_id)}</div></th>
                                                                                                            <th><div className="text-center">{el_fla.info.numero_fornecimentos}</div></th>
                                                                                                            <th><div className="text-center">{el_fla.info.numero_fornecimentos_avaliados}</div></th>
                                                                                                            <th><div className="text-end">{!Number.isNaN(el_fla.info.numero_fornecimentos_avaliados_valor_total) && parseInt(el_fla.info.numero_fornecimentos_avaliados_valor_total) > 0 ? (parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(2) : ''}</div></th>
                                                                                                            <th><div className="text-center">{/*el_fla.info.classificacao*/}{!Number.isNaN(el_fla.info.numero_fornecimentos_avaliados_valor_total) && parseInt(el_fla.info.numero_fornecimentos_avaliados_valor_total) > 0 ? get_supplier_type((parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(2)) : ''}</div></th>
                                                                                                            <th><div className="text-center">{!Number.isNaN(el_fla.info.numero_fornecimentos_avaliados_valor_total) && parseInt(el_fla.info.numero_fornecimentos_avaliados_valor_total) > 0 ? get_supplier_obs((parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(2)) : ''}</div></th>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>

                                                                            <div className={"div-table" + (parseInt(show_table) === 2 ? '' : ' d-none')}>
                                                                                <div className="table-body table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr className="text-white">
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].field_supply_type}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_supplies}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_supplies_evaluated}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_rating_average}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplier_classification}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            suppliers_list_by_tipo_active.current !== undefined && suppliers_list_by_tipo_active.current !== null ?
                                                                                                suppliers_list_by_tipo_active.current.map((el_fla, k_fla) => {
                                                                                                    return (
                                                                                                        <tr key={k_fla}>
                                                                                                            <td><div className="text-nowrap">{parseInt(k_fla + 1)}</div></td>
                                                                                                            <td><div className="text-nowrap">{get_supply_type(el_fla.info.type_id)}</div></td>
                                                                                                            <td><div className="text-center">{el_fla.info.numero_fornecimentos}</div></td>
                                                                                                            <td><div className="text-center">{el_fla.info.numero_fornecimentos_avaliados}</div></td>
                                                                                                            <td><div className="text-end">{(parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(1)}</div></td>
                                                                                                            <td><div className="text-center">{(parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)) > 0 ? get_supply_quality_type((parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(2)) : ''}</div></td>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>

                                                                            <div className={"div-table" + (parseInt(show_table) === 3 ? '' : ' d-none')}>
                                                                                <div className="table-body table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr>
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].field_total_supplies}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplies_evaluated}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_tx_evaluated}</th>
                                                                                                {
                                                                                                evaluating_criteria_types.current !== undefined ?
                                                                                                    evaluating_criteria_types.current.map((el_ect, k_ect) => {
                                                                                                        return (
                                                                                                            <th key={k_ect} className="text-white">{el_ect.label}</th>
                                                                                                        )
                                                                                                    })
                                                                                                :
                                                                                                    null
                                                                                                }
                                                                                                <th className="text-white p-3">{language[lang].field_total_occorences}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_tx_occorences}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            suppliers_list_by_month_active.current !== undefined && suppliers_list_by_month_active.current !== null ?
                                                                                                suppliers_list_by_month_active.current.map((el_fla, k_fla) => {
                                                                                                    return (
                                                                                                        <tr key={k_fla}>
                                                                                                            <td><div className="text-nowrap">{parseInt(k_fla + 1)}</div></td>
                                                                                                            <td><div className="text-nowrap">{get_month_name(el_fla.info.month)}</div></td>
                                                                                                            <td><div className="text-center">{el_fla.info.numero_fornecimentos}</div></td>
                                                                                                            <td><div className="text-center">{el_fla.info.numero_fornecimentos_avaliados}</div></td>
                                                                                                            <td><div className="text-center">{(parseInt(el_fla.info.numero_fornecimentos_avaliados) * 100 / parseInt(el_fla.info.numero_fornecimentos)).toFixed(1)}%</div></td>
                                                                                                            {
                                                                                                            evaluating_criteria_types.current !== undefined ?
                                                                                                                evaluating_criteria_types.current.map((el_ect, k_ect) => {
                                                                                                                    return (
                                                                                                                        <td key={k_ect}><div className={"text-center"}>{el_fla.info['evaluation_type_id_' + el_ect.id]}</div></td>
                                                                                                                    )
                                                                                                                })
                                                                                                            :
                                                                                                                null
                                                                                                            }
                                                                                                            <td>
                                                                                                                <div className="text-center">
                                                                                                                    {
                                                                                                                    evaluating_criteria_types.current !== undefined ?
                                                                                                                        evaluating_criteria_types.current.reduce((a, b) => parseInt(a) + parseInt(el_fla.info['evaluation_type_id_' + b.id]), 0)
                                                                                                                    :
                                                                                                                        null
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <div className="text-center">
                                                                                                                    {
                                                                                                                    evaluating_criteria_types.current !== undefined ?
                                                                                                                        parseFloat(parseInt(evaluating_criteria_types.current.reduce((a, b) => parseInt(a) + parseInt(el_fla.info['evaluation_type_id_' + b.id]), 0)) * 100 / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(1)
                                                                                                                    :
                                                                                                                        null
                                                                                                                    }
                                                                                                                    %
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </tbody>
                                                                                        <tfoot className="bg-secondary">
                                                                                            <tr>
                                                                                                <td><div className="text-center text-white"></div></td>
                                                                                                <td><div className="text-left text-white">Total</div></td>
                                                                                                <td><div className="text-center text-white">{total_fonecimentos.current}</div></td>
                                                                                                <td><div className="text-center text-white">{total_fonecimentos_avaliados.current}</div></td>
                                                                                                <td><div className="text-center text-white">{total_tx_avaliados.current}%</div></td>
                                                                                                {
                                                                                                evaluating_criteria_types.current !== undefined ?
                                                                                                    evaluating_criteria_types.current.map((el_ect, k_ect) => {
                                                                                                        return (
                                                                                                            <td key={k_ect}>
                                                                                                                <div className="text-center text-white">
                                                                                                                    {suppliers_list_by_month_active.current.reduce((a, b) => parseInt(a) + parseInt(b.info['evaluation_type_id_' + el_ect.id]), 0)}
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        )
                                                                                                    })
                                                                                                :
                                                                                                    null
                                                                                                }
                                                                                                <td>
                                                                                                    <div className="text-center text-white">
                                                                                                        {
                                                                                                        evaluating_criteria_types.current !== undefined ?
                                                                                                            evaluating_criteria_types.current.reduce((a, b) => parseInt(a) + parseInt(suppliers_list_by_month_active.current.reduce((a_1, b_1) => parseInt(a_1) + parseInt(b_1.info['evaluation_type_id_' + b.id]), 0)), 0)
                                                                                                        :
                                                                                                            null
                                                                                                        }
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <div className="text-center text-white">
                                                                                                        {
                                                                                                        evaluating_criteria_types.current !== undefined ?
                                                                                                            parseFloat(parseInt(evaluating_criteria_types.current.reduce((a, b) => parseInt(a) + parseInt(suppliers_list_by_month_active.current.reduce((a_1, b_1) => parseInt(a_1) + parseInt(b_1.info['evaluation_type_id_' + b.id]), 0)), 0)) * 100 / parseInt(total_fonecimentos_avaliados.current)).toFixed(1)
                                                                                                        :
                                                                                                            null
                                                                                                        }
                                                                                                        %
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </tfoot>
                                                                                    </table>
                                                                                </div>
                                                                            </div>

                                                                            <div className={"div-table" + (parseInt(show_table) === 4 ? '' : ' d-none')}>
                                                                                <div className="table-body scroll table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr className="text-white">
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplier}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplier_classification}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_supplier_acceptance}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            suppliers_list_by_name_active.current !== undefined && suppliers_list_by_name_active.current !== null ?
                                                                                                suppliers_list_by_name_active.current.map((el_fla, k_fla) => {
                                                                                                    return (
                                                                                                        <tr key={k_fla}>
                                                                                                            <th><div className="text-nowrap">{parseInt(k_fla + 1)}</div></th>
                                                                                                            <th><div className="text-nowrap">{el_fla.info.name}</div></th>
                                                                                                            <th><div className="text-center">{/*el_fla.info.classificacao*/}{!Number.isNaN(el_fla.info.numero_fornecimentos_avaliados_valor_total) && parseInt(el_fla.info.numero_fornecimentos_avaliados_valor_total) > 0 ? get_supplier_type((parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(2)) : ''}</div></th>
                                                                                                            <th><div className="text-center">{/*el_fla.info.classificacao*/}{!Number.isNaN(el_fla.info.numero_fornecimentos_avaliados_valor_total) && parseInt(el_fla.info.numero_fornecimentos_avaliados_valor_total) > 0 ? get_supplier_accepted((parseFloat(el_fla.info.numero_fornecimentos_avaliados_valor_total) / parseInt(el_fla.info.numero_fornecimentos_avaliados)).toFixed(2)) : ''}</div></th>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>

                                                                            <div className={"div-table" + (parseInt(show_table) === 5 ? '' : ' d-none')}>
                                                                                <div className="table-body table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr className="text-white">
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].field_suppliers_class}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_suppliers}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_per_total}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            suppliers_list_by_classificacao_active.current !== undefined && suppliers_list_by_classificacao_active.current !== null ?
                                                                                                suppliers_list_by_classificacao_active.current.map((el_fla, k_fla) => {
                                                                                                    return (
                                                                                                        <tr key={k_fla}>
                                                                                                            <th><div className="text-nowrap">{parseInt(k_fla + 1)}</div></th>
                                                                                                            <th><div className="text-nowrap">{get_supplier_type_name(el_fla.info.classificacao_id)}</div></th>
                                                                                                            <th><div className="text-center">{el_fla.info.numero_fornecedores}</div></th>
                                                                                                            <th>
                                                                                                                <div className="text-center">
                                                                                                                    {
                                                                                                                    parseFloat(parseInt(el_fla.info.numero_fornecedores) * 100 / parseInt(suppliers_list_by_classificacao_active.current.reduce((a, b) => parseInt(a) + parseInt(b.info.numero_fornecedores), 0))).toFixed(1)
                                                                                                                    }
                                                                                                                    %
                                                                                                                </div>
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>

                                                                                <div className="table-body table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr className="text-white">
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].field_suppliers_class}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_supplies}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_supplies_evaluated}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_per_total}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            evaluating_supply_types.current !== undefined && evaluating_supply_types.current !== null && suppliers_list_by_classificacao_tipo_prod_2_active.current !== undefined && suppliers_list_by_classificacao_tipo_prod_2_active.current !== null ?
                                                                                                evaluating_supply_types.current.map((el_est, k_est) => {
                                                                                                    return (
                                                                                                        suppliers_list_by_classificacao_tipo_prod_2_active.current.filter(e => (parseInt(e.info.type_id) === parseInt(el_est.id) && e.info.classificacao_id !== '')).map((el_fla, k_fla) => {
                                                                                                            if(k_fla === 0) {
                                                                                                                return (
                                                                                                                    <>
                                                                                                                        <tr>
                                                                                                                            <th><div className="text-nowrap"><strong>{parseInt(k_est + 1)}</strong></div></th>
                                                                                                                            <th><div className="text-nowrap"><strong>{el_fla.info.type}</strong></div></th>
                                                                                                                            <th><div className="text-center"><strong>{suppliers_list_by_classificacao_tipo_prod_2_active.current.filter(e => parseInt(e.info.type_id) === parseInt(el_est.id)).reduce((a, b) => parseInt(a) + parseInt(b.info.numero_fornecimentos), 0)}</strong></div></th>
                                                                                                                            <th><div className="text-center"><strong>{suppliers_list_by_classificacao_tipo_prod_2_active.current.filter(e => parseInt(e.info.type_id) === parseInt(el_est.id)).reduce((a, b) => parseInt(a) + parseInt(b.info.numero_fornecimentos_avaliados), 0)}</strong></div></th>
                                                                                                                            <th>
                                                                                                                                <div className="text-center">
                                                                                                                                    <strong>
                                                                                                                                        {
                                                                                                                                        parseFloat(parseInt(suppliers_list_by_classificacao_tipo_prod_2_active.current.filter(e => parseInt(e.info.type_id) === parseInt(el_est.id)).reduce((a, b) => parseInt(a) + parseInt(b.info.numero_fornecimentos_avaliados), 0)) * 100 / parseInt(suppliers_list_by_classificacao_tipo_prod_2_active.current.reduce((a, b) => parseInt(a) + parseInt(b.info.numero_fornecimentos_avaliados), 0))).toFixed(1)
                                                                                                                                        }
                                                                                                                                        %
                                                                                                                                    </strong>
                                                                                                                                </div>
                                                                                                                            </th>
                                                                                                                        </tr>
                                                                                                                        <tr>
                                                                                                                            <th><div className="text-nowrap"></div></th>
                                                                                                                            <th><div className="text-nowrap text-end">{get_supply_type_name(el_fla.info.classificacao_id)}</div></th>
                                                                                                                            <th><div className="text-center"></div></th>
                                                                                                                            <th><div className="text-center">{el_fla.info.numero_fornecimentos_avaliados}</div></th>
                                                                                                                            <th>
                                                                                                                                <div className="text-center">
                                                                                                                                    {
                                                                                                                                    parseFloat(parseInt(el_fla.info.numero_fornecimentos_avaliados) * 100 / parseInt(suppliers_list_by_classificacao_tipo_prod_2_active.current.filter(e => parseInt(e.info.type_id) === parseInt(el_est.id)).reduce((a, b) => parseInt(a) + parseInt(b.info.numero_fornecimentos_avaliados), 0))).toFixed(1)
                                                                                                                                    }
                                                                                                                                    %
                                                                                                                                </div>
                                                                                                                            </th>
                                                                                                                        </tr>
                                                                                                                    </>
                                                                                                                )
                                                                                                            }
                                                                                                            else {
                                                                                                                return (
                                                                                                                    <tr key={k_fla}>
                                                                                                                        <th><div className="text-nowrap"></div></th>
                                                                                                                        <th><div className="text-nowrap text-end">{get_supply_type_name(el_fla.info.classificacao_id)}</div></th>
                                                                                                                        <th><div className="text-center"></div></th>
                                                                                                                        <th><div className="text-center">{el_fla.info.numero_fornecimentos_avaliados}</div></th>
                                                                                                                        <th>
                                                                                                                            <div className="text-center">
                                                                                                                                {
                                                                                                                                parseFloat(parseInt(el_fla.info.numero_fornecimentos_avaliados) * 100 / parseInt(suppliers_list_by_classificacao_tipo_prod_2_active.current.filter(e => parseInt(e.info.type_id) === parseInt(el_est.id)).reduce((a, b) => parseInt(a) + parseInt(b.info.numero_fornecimentos_avaliados), 0))).toFixed(1)
                                                                                                                                }
                                                                                                                                %
                                                                                                                            </div>
                                                                                                                        </th>
                                                                                                                    </tr>
                                                                                                                )
                                                                                                            }
                                                                                                        })
                                                                                                    )
                                                                                                })
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>

                                                                                <div className="table-body table-responsive">
                                                                                    <table className="table suppliers-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr className="text-white">
                                                                                                <th className="text-white p-3"></th>
                                                                                                <th className="text-white p-3">{language[lang].field_per_compliance}</th>
                                                                                                <th className="text-white p-3">{language[lang].field_per_compliance}<br /><small>{language[lang].field_per_compliance_desc}</small></th>
                                                                                                <th className="text-white p-3">{language[lang].field_n_occurence}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            evaluating_criteria_types.current !== undefined ?
                                                                                                evaluating_criteria_types.current.map((el_ect, k_ect) => {
                                                                                                    return (
                                                                                                        <tr key={k_ect}>
                                                                                                            <td>{parseInt(k_ect) + 1}</td>
                                                                                                            <td>{el_ect.label}</td>
                                                                                                            <td>
                                                                                                                <div className="text-center">
                                                                                                                    {
                                                                                                                    parseFloat((parseInt(total_fonecimentos_avaliados.current) - parseInt(suppliers_list_by_month_active.current.reduce((a, b) => parseInt(a) + parseInt(b.info['evaluation_type_id_' + el_ect.id]), 0))) * 100 / parseInt(total_fonecimentos_avaliados.current)).toFixed(1)
                                                                                                                    }
                                                                                                                    %
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <div className="text-center">
                                                                                                                    {suppliers_list_by_month_active.current.reduce((a, b) => parseInt(a) + parseInt(b.info['evaluation_type_id_' + el_ect.id]), 0)}
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>

                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                :
                                                    null
                                                }
                                            </div>

                                            <div className="modal bg-light fade" tabIndex="-1" id={"insert_modal"}>
                                                <div className="modal-dialog modal-lg modal-dialog-centered">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title">{language[lang].add_new}</h5>
                        
                                                            <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                                                <i className="bi bi-x fs-2"></i>
                                                            </div>
                                                        </div>
                        
                                                        <div className="modal-body">
                                                            <div className="row mb-3">
                                                                <div className="col-6 col-md-4">
                                                                    <label className="col-form-label fw-bold fs-6">{language[lang].field_number}</label>
                                                                    <input type="text" className="form-control rounded-0" name="numero" value={new_row?.current?.info?.settings?.numero ? new_row.current.info.settings.numero : ''} onChange={(e) => change_settings_new_row(e)} /> 
                                                                </div>
                                                                <div className="col-6 col-md-4">
                                                                    <label className="col-form-label fw-bold fs-6">{language[lang].table_date}</label>
                                                                    <input type="date" className="form-control rounded-0" name="data" value={new_row?.current?.info?.settings?.data !== undefined ? new_row.current.info.settings.data : ''} onChange={(e) => change_settings_new_row(e)} />
                                                                </div>
                                                            </div>
                        
                                                            <div className="row mb-3">
                                                                <div className="col-6 col-md-8">
                                                                    <label className="col-form-label fw-bold fs-6">{language[lang].field_name}</label>
                                                                    <select
                                                                        name="nome"
                                                                        className="form-select form-control mb-2 rounded-0"
                                                                        onChange={change_settings_new_row}
                                                                        value={new_row?.current?.info?.settings?.entity?.id !== undefined && new_row?.current?.info?.settings?.entity?.id !== null ? new_row.current.info.settings.entity.id : ''}
                                                                    >
                                                                        <option value="">{language[lang].field_choose}</option>
                                                                        {
                                                                        entities_list.current !== undefined && entities_list.current !== null ?
                                                                            entities_list.current.map((el_el, k_el) => (
                                                                                <option key={k_el} value={el_el.id}>
                                                                                    {el_el.label}
                                                                                </option>
                                                                            ))
                                                                        :
                                                                            null
                                                                        }
                                                                    </select>

                                                                    <input type="text" className="form-control rounded-0 d-none" name="nome" value={new_row?.current?.info?.settings?.nome ? new_row.current.info.settings.nome : ''} onChange={(e) => change_settings_new_row(e)} /> 
                                                                </div>
                                                                <div className="col-6 col-md-4">
                                                                    <label className="col-form-label fw-bold fs-6">{language[lang].field_type}</label>

                                                                    <select
                                                                        name="tipo_id"
                                                                        className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                        onChange={(e) => change_settings_new_row(e)}
                                                                        value={new_row?.current?.info?.settings?.tipo_id !== undefined && new_row?.current?.info?.settings?.tipo_id !== null ? new_row.current.info.settings.tipo_id : ''}
                                                                    >
                                                                        <option value="">{language[lang].field_choose}</option>
                                                                        {
                                                                        evaluating_supply_types.current !== undefined && evaluating_supply_types.current !== null ?
                                                                            evaluating_supply_types.current.map((el_est, k_est) => {
                                                                                return (
                                                                                    <option key={k_est} value={el_est.id}>{el_est.label}</option>
                                                                                )
                                                                            })
                                                                        :
                                                                            null
                                                                        }
                                                                    </select>
                                                                    <input type="text" className="form-control rounded-0 d-none" name="tipo" value={new_row?.current?.info?.settings?.tipo ? new_row.current.info.settings.tipo : ''} onChange={(e) => change_settings_new_row(e)} /> 
                                                                </div>
                                                            </div>
                        
                                                            <div className="row mb-3">
                                                                <div className="col-6 col-md-4">
                                                                    <label className="fs-6 fw-bold mb-2">{language[lang].field_avaliado}</label>
                                                                    <select
                                                                        name="avaliado"
                                                                        className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                        onChange={(e) => change_settings_new_row(e)}
                                                                        value={new_row?.current?.info?.settings?.avaliado !== undefined && new_row?.current?.info?.settings?.avaliado !== null ? new_row.current.info.settings.avaliado : ''}
                                                                    >
                                                                        <option value="">{language[lang].field_choose}</option>
                                                                        <option value="true">Sim</option>
                                                                        <option value="false">Não</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            {
                                                            new_row?.current?.info?.settings?.avaliado !== undefined && new_row?.current?.info?.settings?.avaliado !== null && new_row.current.info.settings.avaliado === true ? 
                                                                <div className="row mb-3">
                                                                    {
                                                                    evaluating_criteria_types.current !== undefined ?
                                                                        evaluating_criteria_types.current.map((el_ect, k_ect) => {
                                                                            return (
                                                                                <div key={k_ect} className="col-6 col-md-4 mb-3">
                                                                                    <label className="fs-6 fw-bold mb-2">{el_ect.label}?</label>
                                                                                    <select
                                                                                        name={"evaluation_type_id_" + el_ect.id}
                                                                                        className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                        onChange={(e) => change_settings_new_row(e)}
                                                                                        value={new_row?.current?.info?.settings['evaluation_type_id_'+ el_ect.id] !== undefined && new_row?.current?.info?.settings['evaluation_type_id_'+ el_ect.id] !== null ? new_row.current.info.settings['evaluation_type_id_'+ el_ect.id] : ''}
                                                                                    >
                                                                                        <option value="">{language[lang].field_choose}</option>
                                                                                        <option value="true">Sim</option>
                                                                                        <option value="false">Não</option>
                                                                                    </select>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    :
                                                                        null
                                                                    }
                                                                </div>
                                                            :
                                                                null
                                                            }
                        
                        
                                                            <div className="row mb-3">
                                                                <div className="col-4 col-md-4 d-none">
                                                                    <label className="col-form-label fw-bold fs-6">{language[lang].field_avaliacao_final}</label>
                                                                    <input type="text" className="form-control rounded-0" name="avaliacao_final" value={new_row?.current?.info?.settings?.avaliacao_final ? new_row.current.info.settings.avaliacao_final : ''} onChange={(e) => change_settings_new_row(e)} /> 
                                                                </div>
                                                                <div className="col-8 col-md-8 d-none">
                                                                    <label className="col-form-label fw-bold fs-6">{language[lang].field_classificacao_fornecimento}</label>
                                                                    <input type="text" className="form-control rounded-0" name="classificacao" value={new_row?.current?.info?.settings?.classificacao ? new_row.current.info.settings.classificacao : ''} onChange={(e) => change_settings_new_row(e)} /> 
                                                                </div>
                                                            </div>
                                                        </div>
                        
                                                        <div className="modal-footer">
                                                            <button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
                                                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => save_row()}>{language[lang].save}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}